import { render, staticRenderFns } from "./mensagemTempo.vue?vue&type=template&id=02dd02f1"
import script from "./mensagemTempo.ts?vue&type=script&lang=js&external"
export * from "./mensagemTempo.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02dd02f1')) {
      api.createRecord('02dd02f1', component.options)
    } else {
      api.reload('02dd02f1', component.options)
    }
    module.hot.accept("./mensagemTempo.vue?vue&type=template&id=02dd02f1", function () {
      api.rerender('02dd02f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/atendimento/mensagem/mensagemTempo/mensagemTempo.vue"
export default component.exports